import { useQuery } from "react-query";
import { RestError } from "../../../services/rest-service/RestService";
import { ICompressorLynxGridModel } from "../../../services/summary-listing-data-service/CompressorLynxSummaryModels";
import SummaryListingDataService from "../../../services/summary-listing-data-service/SummaryListingDataService";
import { BaseUseQueryParameters } from "../../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseCompressorLynxSummaryDataParameters = {
    groupID: number
} & BaseUseQueryParameters<ICompressorLynxGridModel>;

export function useCompressorLynxSummaryData({
    groupID,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseCompressorLynxSummaryDataParameters) {
    return useQuery<ICompressorLynxGridModel, RestError>(
        keys.summaryData(groupID),
        ({ signal }) => {
            return SummaryListingDataService.getCompressorLynxData(groupID, signal);
        },
        {
            enabled,
            onError,
            onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false
        }
    );
}
